import { useEffect } from 'react'
import Userback from '@userback/widget'

interface UserbackWidgetProps {
  token?: string
}

export default function UserbackWidget({ token }: UserbackWidgetProps) {
  useEffect(() => {
    const userbackToken = token || import.meta.env.VITE_USERBACK_TOKEN

    if (userbackToken) {
      Userback(userbackToken)
      console.log('Userback feedback widget initialized')
    } else {
      console.warn('Userback token not found. Set VITE_USERBACK_TOKEN in your .env file.')
    }

    return () => {
      const widget = document.getElementById('userback_button_container')
      if (widget) {
        widget.remove()
      }
    }
  }, [token])

  return null
}

